angular.module('webtrader').service('Quotes', function($rootScope, $http, $q, Account, Feed, QuoteOption, Quote) {
  this.init = () => {
    Feed.stream.on('quote', this.onQuote.bind(this))

    this.mapping = {} // maps internal quote name to quote object(like AUDUSD_OP)
    this.shortMapping = {} // maps actual quote name to quote object(like AUDUSD)
    this.objects = []

    this.quoteClass = Account.info.group.is_options? QuoteOption : Quote
    for (let quote of Account.info.instruments) {
      let o = new this.quoteClass(quote)
      this.objects.push(o)
      this.mapping[o.symbol] = o
      this.shortMapping[o.short_symbol] = o

      Feed.stream.subscribeQuote(o.symbol)
    }

    this.grouped = _.groupBy(this.objects, (o) => o.group)
    this.groupes = _(this.grouped).keys().compact().value()
    this.symbols = _.keys(this.mapping)

    this.selectSymbol(Account.getVar("quotesSymbol"))
  }

  this.deinit = () => {

  }

  this.onQuote = (symbol, data) => {
    if(this.timestamp && data.timestamp < this.timestamp)
      return

    this.timestamp = data.time
    this.mapping[symbol].update(data)
    /* since we got websocket feed time in utc, rather than in server time, like backend does */
    this.time = this.mapping[symbol].time = this.mapping[symbol].time.utc()

    if(!$rootScope.$$phase)
      $rootScope.$digest()
  }

  this.selectSymbol = (symbol) => {
    if (!this.mapping[symbol])
      symbol = Account.info.default_symbol
    this.currentSymbol = symbol
    this.currentQuote = this.mapping[symbol]
    Account.setVar("quotesSymbol", this.currentSymbol)
    $rootScope.$broadcast("quotes:select", symbol)
  }

  this.convertCurrency = (amount, from, to) => {
    /* Just to be convinient */
    if (from == 'RUR')
      from = 'RUB'
    if (to == 'RUR')
      to = 'RUB'
    if (from == 'mBTC')
      from = 'BTN'
    if (to == 'mBTC')
      to = 'BTN'
    if (from == 'XAG' && to == 'USD') {
      from = 'SIL'
      to = 'VER'
    }
    if (to == 'XAG' && from == 'USD') {
      from = 'VER'
      to = 'SIL'
    }
    if (from == 'XAU' && to == 'USD') {
      from = 'GO'
      to = 'LD'
    }
    if (to == 'XAU' && from == 'USD') {
      from = 'LD'
      to = 'GO'
    }

    if (from == to) {
      return amount
    }

    let quote = null

    /* We are buying our volume to get desired currency */
    if (quote = this.shortMapping[from + to]) {
      return amount * quote.ask
    }

    /* We are selling our volume to get desired currency */
    if (quote = this.shortMapping[to + from]) {
      return amount / quote.bid
    }

    /* Cross-conversion via USD as last resort */
    if (quote = this.shortMapping[from + "USD"])
      return this.convertCurrency(amount, "USD", to) * quote.bid

    if (quote = this.shortMapping["USD" + from])
      return this.convertCurrency(amount, "USD", to) / quote.ask
  }

})
